var AWIN = AWIN || {};
AWIN.Tracking = AWIN.Tracking || {};
AWIN.Tracking.AdvertiserConsent = false;

document.addEventListener("DOMContentLoaded", () => {
  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1",
      },
    ],
    (error) => {
      if (error) {
        return;
      }

      function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      }

      async function waitForAwin(execute) {
        while (typeof AWIN.Tracking !== "object" || typeof AWIN.Tracking.Consent !== "object" || typeof AWIN.Tracking.Consent.setAdvertiserConsentStatus !== "function") {
          await sleep(1000);
        }
        execute();
      }

      waitForAwin(() => {
        console.log(AWIN);
        console.log(AWIN.Tracking);
        console.log(AWIN.Tracking.Consent);
        const advertiserConsent =
          window.Shopify.customerPrivacy.marketingAllowed();
        AWIN.Tracking.Consent.setAdvertiserConsentStatus(advertiserConsent);
        console.log("Setting awin consent to ", advertiserConsent);

        document.addEventListener("visitorConsentCollected", (event) => {
          const analyticsAllowed = event.detail.analyticsAllowed;
          AWIN.Tracking.Consent.setAdvertiserConsentStatus(analyticsAllowed);
          console.log("Setting awin consent to ", analyticsAllowed);
        });
      });
    }
  );
});
